import { render, staticRenderFns } from "./DaiP.vue?vue&type=template&id=53e94632"
import script from "./DaiP.vue?vue&type=script&lang=js"
export * from "./DaiP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports